enum ActionTypes {
  LOAD_BACK_OFFICE_ENTERPRISE_REQUEST = 'LOAD_BACK_OFFICE_ENTERPRISE_REQUEST',
  LOAD_BACK_OFFICE_ENTERPRISE_SUCCESS = 'LOAD_BACK_OFFICE_ENTERPRISE_SUCCESS',
  LOAD_BACK_OFFICE_ENTERPRISE_FAILURE = 'LOAD_BACK_OFFICE_ENTERPRISE_FAILURE',

  SET_BACK_OFFICE_ENTERPRISE = 'SET_BACK_OFFICE_ENTERPRISE'
}

export default ActionTypes;
